import { SmallButton } from "@sellar-io/components";
import { ReactElement, useEffect } from "react";
import { useNavigate } from "react-router";
import { Icon, SpinnerLegacy } from "../../components";
import { useDashboardContext } from "../../components/dashboard/Dashboard.shared";
import { InfiniteList } from "../../components/infiniteLoading/InfiniteList";
import { NavigationBarMenu } from "../../components/navigation/NavigationBar";
import { StatePrompts } from "../../components/statePrompts/statePrompts";
import { COLLECTION_DETAILS, NEW_COLLECTION } from "../../constants/routes";
import { useCollectionList } from "../../hooks/api/v2/collections/useCollectionList";
import { useParamAsNumber } from "../../hooks/useParamAsNumber";
import CollectionListItem from "./CollectionListItem";

export function CollectionsList(): ReactElement {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-full flex-col bg-gray-100">
      <NavigationBarMenu
        title={"Collections"}
        rightComponent={
          <SmallButton onClick={() => navigate(NEW_COLLECTION)}>
            <Icon icon={"PLUS"} size={0.7} /> New
          </SmallButton>
        }
      />
      <Courier />
    </div>
  );
}

const Courier = () => {
  const collectionQuery = useCollectionList({
    query: [],
    limit: 10,
    sortBy: "collectionDate",
    sortDir: "desc",
  });

  const { isTwoPanel } = useDashboardContext();
  const collectionId = useParamAsNumber(
    COLLECTION_DETAILS,
    "collectionId",
    false,
  );
  const navigate = useNavigate();
  useEffect(() => {
    if (isTwoPanel && collectionQuery.data?.pages[0]?.length && !collectionId) {
      //if two panel layout and no collection is selected, automatically select first one

      const firstCollection = collectionQuery.data.pages[0][0];

      if (firstCollection) {
        navigate(
          COLLECTION_DETAILS.href({ collectionId: firstCollection.id }),
          {
            replace: true,
          },
        );
      }
    }
  }, [isTwoPanel, collectionId, collectionQuery.data?.pages, navigate]);

  if (collectionQuery.isLoading) {
    return <SpinnerLegacy />;
  }

  if (!collectionQuery.data?.pages[0]?.length) {
    return (
      <div className="p-4">
        <StatePrompts
          title="No collections yet"
          description="Book and manage collections for your Courier UPS orders here."
          primaryCta="New collection"
          icon="PLUS"
          onClick={() => navigate(NEW_COLLECTION)}
        />
      </div>
    );
  }

  return (
    <InfiniteList query={collectionQuery}>
      {collectionQuery.data.pages.map((page) =>
        page.map((collection) => (
          <CollectionListItem key={collection.id} collection={collection} />
        )),
      )}
    </InfiniteList>
  );
};
